module.exports = __webpack_public_path__ + "static/darwin-03-93e27f35a47aa545d394d0522d3494fb.jpg";